var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "新增",
        width: "500px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "addTargetSetting overflowOuto" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择月份", prop: "monthYear" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      format: "yyyy-MM",
                      "value-format": "yyyyMM",
                      size: "small",
                      type: "month",
                      placeholder: "请选择",
                      filterable: "",
                      clearable: "",
                      "picker-options": _vm.pickerOptions,
                    },
                    model: {
                      value: _vm.form.monthYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "monthYear", $$v)
                      },
                      expression: "form.monthYear",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择员工", prop: "userList" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addUser },
                    },
                    [_vm._v("选择")]
                  ),
                  _c("div", [
                    _c(
                      "div",
                      { class: { assessBox: _vm.form.userList.length > 0 } },
                      _vm._l(_vm.form.userList, function (tag, index) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.userId,
                            staticClass: "remindPersonListView",
                            attrs: {
                              closable: !_vm.defaultDisabledUser.includes(
                                tag.userId
                              ),
                            },
                            on: {
                              close: function ($event) {
                                return _vm.delAssistant(tag, index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(tag.nickName))]
                        )
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "目标值", prop: "number" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    on: { input: _vm.delNumber },
                    model: {
                      value: _vm.form.targetValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "targetValue", $$v)
                      },
                      expression: "form.targetValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }